module.exports = __webpack_public_path__ + "static/chronos_hero-ffb4a5fec25e7a82636e2fd63df96721.jpg";